import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MissionStripComponent } from './components/mission-strip/mission-strip';
import { CartService } from './services/cart.service';
import { DemoIdentityService } from './services/demo-identity.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MissionStripComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css'
})
export class App {
  protected title = 'OrderUp - Angular v22';

  constructor(
    public cartService: CartService,
    // Injected for its side effects: creates/loads the visitor's demoCode
    // and keeps it stamped on the browser agent's data (spec section 1).
    demoIdentity: DemoIdentityService
  ) {}
}
